import { useContext, useEffect } from 'react';
import { StripeContext } from './context.js';

var STRIPE_PAYMENT_METHOD_CODE = "Crossroads_Stripe_PaymentIntents";
var getBillingAddress = function getBillingAddress(addresses) {
  return addresses.find(function (a) {
    return a.type === "billing";
  });
};
var useInitStripeQuotePaymentMethod = function useInitStripeQuotePaymentMethod(quote) {
  var _useContext = useContext(StripeContext),
    setBillingAddress = _useContext.setBillingAddress,
    setEmail = _useContext.setEmail;
  var _ref = quote || {},
    payment = _ref.payment,
    addresses = _ref.addresses,
    email = _ref.email;
  var billingAddress = getBillingAddress(addresses || []);
  var paymentCode = payment == null ? void 0 : payment.code;
  var stripeKey = payment && payment.code === STRIPE_PAYMENT_METHOD_CODE ? payment.publishableKey : null;

  // Update stripe billing address on quote update
  useEffect(function () {
    if (billingAddress) {
      setBillingAddress(billingAddress);
    }
  }, [billingAddress, setBillingAddress]);

  // Update stripe email on quote update
  useEffect(function () {
    if (typeof email === "string") {
      setEmail(email);
    }
  }, [email, setEmail]);
  if (!stripeKey && paymentCode === STRIPE_PAYMENT_METHOD_CODE) {
    throw new Error("Could not load Stripe: No publishableKey found in quote.payment");
  }
};

export { STRIPE_PAYMENT_METHOD_CODE, useInitStripeQuotePaymentMethod };
//# sourceMappingURL=quote-payment-method.js.map
